import { useTranslation } from '@mint-lib/i18n';
import { Tabs, TabsList, TabsTrigger } from '@mint-lib/tw-components';

export type LabelsTabsProps = {
  isMint2: boolean;
  categoryType: string;
  setCategoryType: (categoryType: string) => void;
  setSearchValue: (searchValue: string) => void;
  tabs?: { id: string; name: string }[];
};

export const LabelsTabs = ({
  setCategoryType,
  setSearchValue,
  isMint2,
  categoryType,
  tabs,
}: LabelsTabsProps) => {
  const { t } = useTranslation('@mint-lib/labels-table');

  return (
    <Tabs
      defaultValue={categoryType}
      orientation="horizontal"
      className="overflow-y-auto"
      onValueChange={(value) => {
        setCategoryType(value);
        setSearchValue('');
      }}
      value={categoryType}
    >
      {isMint2 ? (
        <TabsList>
          {tabs?.map((tab) => (
            <TabsTrigger value={tab.name} key={tab.id}>
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>
      ) : (
        <TabsList>
          <TabsTrigger value={'brands'} key={'brands'}>
            {t('Brands & Products')}
          </TabsTrigger>
          <TabsTrigger value={'geographies'} key={'geo'}>
            {t('Geographies')}
          </TabsTrigger>
        </TabsList>
      )}
    </Tabs>
  );
};
